import { ExclamationCircleFilled } from '@ant-design/icons';
import Link from 'next/link';
import { useRouter } from 'next/router';
import React from 'react';
import { useRecoilValue } from 'recoil';

import { user } from '@/atoms/user';
import { User } from '@/utils/interfaces/User';

interface CorporateLowBalanceBannerProps {
  threshold?: number;
}

const CorporateLowBalanceBanner: React.FC<CorporateLowBalanceBannerProps> = ({
  threshold = 1000,
}) => {
  const router = useRouter();
  const userData: User | undefined = useRecoilValue(user);

  const org = (userData as any)?.organization;
  if (!org) return null;

  const rawBalance = org.wallet_balance ?? 0;
  // Balance is in paise (e.g. 10000 paise = ₹100)
  const availableBalance = Number(rawBalance) / 100;

  if (availableBalance >= threshold) {
    return null;
  }

  const isWalletPage = router.pathname === '/corporate/wallet';
  const isAdmin = org.role === 'admin';

  return (
    <div className='w-full bg-[#1C1204]  px-4 sm:px-6 py-3.5 text-left select-none'>
      <div className='max-w-6xl mx-auto flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3'>
        <div className='flex items-start gap-3'>
          <ExclamationCircleFilled className='text-[#F59E0B] text-base mt-0.5 flex-shrink-0' />
          <div>
            <div className='text-[#F59E0B] font-bold text-sm leading-tight'>
              Insufficient balance
            </div>
            <p className='text-xs text-grayZl-300 mt-0.5 leading-relaxed'>
              Your available corporate balance is ₹{Number(availableBalance).toLocaleString('en-IN')}. Please top up to maintain uninterrupted access.
            </p>
          </div>
        </div>
        {isAdmin && !isWalletPage && (
          <Link
            href='/corporate/wallet'
            className='self-start sm:self-center px-4 py-1.5 rounded-xl bg-[#FF5612] hover:bg-[#E54D10] text-white font-semibold text-xs transition-colors flex-shrink-0 shadow cursor-pointer'
          >
            Top Up Wallet
          </Link>
        )}
      </div>
    </div>
  );
};

export default CorporateLowBalanceBanner;
